import { ColDef } from "ag-grid-community";
import { textFilterParams } from "~utils/Grids/ColumnTypes/TextColumn.ts";

/**
 * Set column type for the ag-grid.
 */
export const OneToManyColumn: ColDef = {
	filter: "agTextColumnFilter",
	floatingFilter: true,
	filterParams: textFilterParams,
	valueFormatter(params) {
		const items = params.value || [];
		return items.length < 2 ? items.map((it) => it.name).join(", ") : `${items.length} items`;
	},
};
